
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/training/trainer-agreement-form-manual",
      function () {
        return require("private-next-pages/training/trainer-agreement-form-manual.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/training/trainer-agreement-form-manual"])
      });
    }
  